<template>
    <section class="container-fluid top">
        <div class="row more-top" data-aos="fade-up">
            <div class="col-12 ">
                <div class="row d-none d-md-flex">
                    <div class="col-12 p-5" >
                        <h3 class="title-subtitle text-center bold">{{$store.state.lang == 'es' ? 'Proceso Creativo' : 'Behind the Work'}}</h3>
                    </div>
                </div>
                <div class="row d-none d-md-flex">
                    <div class="col-4" >
                        <div v-for="(item,x) in col1" :key="x" class="pb-4 p-1">
                            <img  :src="$url+'/'+item.image" class="img-fluid cursor-pointer" alt="behind the work"/>
                            <p v-show="false" style="white-space:pre-line">
                                {{ $store.state.lang == 'es' ? item.description_es : item.description_en }}<br>
                            </p>
                        </div>
                    </div>

                    <div class="col-4">
                        <div v-for="(item,y) in col2" :key="y" class="pb-4 p-1">
                            <img  :src="$url+'/'+item.image" class="img-fluid cursor-pointer" alt="behind the work"/>
                            <p v-show="false" style="white-space:pre-line">
                                {{ $store.state.lang == 'es' ? item.description_es : item.description_en }}<br>
                            </p>
                        </div>
                    </div>
                    <div class="col-4">
                        <div v-for="(item,y) in col3" :key="y" class="pb-4 p-1">
                            <img  :src="$url+'/'+item.image" class="img-fluid cursor-pointer" alt="behind the work"/>
                            <p v-show="false" style="white-space:pre-line">
                                {{ $store.state.lang == 'es' ? item.description_es : item.description_en }}<br>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="row d-md-none">
                    <div class="col-12 pb-3" v-for="(item,x) in all" :key="x" >
                        <img  :src="$url+'/'+item.image" class="img-fluid"  alt="behind the work"/>
                        <p v-show="false" style="white-space:pre-line">
                            {{ $store.state.lang == 'es' ? item.description_es : item.description_en }}<br>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-9">
                
            </div>
            <div class="col-3">
                
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios'
export default {
    name: 'BehindTheWork',
    data(){
        return{
            col1:{},
            col2:{},
            col3:{},
            all:{},
        }
    },
    created(){
        this.getArtworks()
    },
  
    methods:{
        async getArtworks(){
            await axios.get(this.$url+'/studio',{
                headers: {'Content-Type' : 'application/json'}
            })
            .then((res)=>{
                this.col1 = res.data.col1
                this.col2 = res.data.col2
                this.col3 = res.data.col3
                this.all = res.data.all
            }).catch((err)=>{
                console.log(err)
            })
        },
        
    },
    
}
</script>